export default "__VITE_ASSET__By_rqMrN__"